<template>
    <div class="jingtan hml_whplt">
        <img src="@/assets/img/secondLevelPage/jingtanMap.png" class="jingtanBg">
        <ul class="list">
            <li
            v-for="(item,index) in list"
            :key="index"
            :class="['list_'+item.id]"
            @click="jingtanClick(index)"
            >
                <img :src="item.url" :style="{width: item.width,height: item.height}">
                <h2>{{ item.title }}</h2>
            </li>
        </ul>
    </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
let publicData = createNamespacedHelpers("publicData");
export default {
    data() { 
        return {
            list: [
                /* {
                    id: 0,
                    title: "绿林山",
                    url: require("@/assets/img/secondLevelPage/jingtan01.png"),
                },
                {
                    id: 1,
                    title: "苏家垄",
                    url: require("@/assets/img/secondLevelPage/jingtan02.png"),
                },
                {
                    id: 2,
                    title: "小焕岭",
                    url: require("@/assets/img/secondLevelPage/jingtan03.png"),
                },
                {
                    id: 3,
                    title: "张文秋故居",
                    url: require("@/assets/img/secondLevelPage/jingtan04.png"),
                },
                {
                    id: 4,
                    title: "文峰塔",
                    url: require("@/assets/img/secondLevelPage/jingtan05.png"),
                },
                {
                    id: 5,
                    title: "戒石铭",
                    url: require("@/assets/img/secondLevelPage/jingtan06.png"),
                },
                {
                    id: 6,
                    title: "屈家岭",
                    url: require("@/assets/img/secondLevelPage/jingtan07.png"),
                } */
            ],
        }
    },
    created(){
        this.list = this.staticeData.jingtanList;
        console.log(this.list);
    },
    methods: {
        jingtanClick(index){
            let array = this.allData[this.firstLevelIndex].dataArr[this.secondLevelIndex].list;
             // console.log(array);
            for(let j = 0; j < array.length; j++){
                if(this.list[index].title == array[j].title){
                    // console.log(array[j].title);
                    this.setIndex({levelThreeIndex: j});
                    this.$router.push("/millenniumDetails")
                    break;
                }
            }
        },
        ...publicData.mapMutations(["setIndex"])
    },
    computed: {
        ...publicData.mapState(["allData","firstLevelIndex","secondLevelIndex","staticeData"])
    },
}
</script>

<style lang="scss" scoped>
.jingtan{
    .jingtanBg,.list{
        width: 7.5rem;
        height: 9.65rem;
        position: absolute;
        left: 50%;
        top: 54%;
        transform: translate(-50%,-50%);
    }
    .list{
        li{
            position: absolute;
            font-size: .28rem;
            color: #fff;
            h2{
                width: 1.63rem;
                height: .5rem;
                background: url(../../../assets/img/secondLevelPage/jingtanTitle.png) no-repeat;
                background-size: 100% 100%;
                text-align: center;
                line-height: .5rem;
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                bottom: -.3rem;
                font-family: "siyuan";
                                  
            }
            &.list_0{
                top: -.46rem;
                left: 3.24rem;
                img{
                    width: 1.42rem;
                    height: .74rem;
                }
            }
            &.list_1{
                top: .08rem;
                right: .92rem;
                img{
                    width: .76rem;
                    height: 1.5rem;
                }
            }
            &.list_2{
                top: 1.82rem;
                right: 1.52rem;
                img{
                    width: 1.56rem;
                    height: .64rem;
                }
            }
            &.list_3{
                top: 2.96rem;
                left: 2.14rem;
                img{
                    width: 2.02rem;
                    height: .96rem;
                }
            }
            &.list_4{
                top: 3.56rem;
                left: 4rem;
                img{
                    width: .61rem;
                    height: 1.92rem;
                }
            }
            &.list_5{
                bottom: 2.37rem;
                left: 2.64rem;
                img{
                    width: 1.48rem;
                    height: .94rem;
                }
            }
            &.list_6{
                bottom: 1.98rem;
                left: .22rem;
                img{
                    width: 1.65rem;
                    height: .78rem;
                }
            }
            &.list_7{
                top: 1.56rem;
                left: 2.92rem;
            }
            &.list_8{
                top: 3.08rem;
                right: 1.38rem;
            }
        }
    }
}
</style>